import $foreign from "./foreign.cjs";
var cons = $foreign.cons;
var join = $foreign.join;
var showArrayImpl = $foreign.showArrayImpl;
var showCharImpl = $foreign.showCharImpl;
var showIntImpl = $foreign.showIntImpl;
var showNumberImpl = $foreign.showNumberImpl;
var showStringImpl = $foreign.showStringImpl;
export { cons, join, showArrayImpl, showCharImpl, showIntImpl, showNumberImpl, showStringImpl };
